import { WarrantyTerms } from './containers/warranty-terms'

export default WarrantyTerms
